import React from 'react';
import { NavLink } from 'react-router-dom';
import { XIcon } from 'lucide-react';
interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}
export function MobileMenu({
  isOpen,
  onClose
}: MobileMenuProps) {
  return <>
      {/* Backdrop */}
      <div className={`fixed inset-0 bg-[#2D1A1A] bg-opacity-50 z-40 transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={onClose} data-id="element-132" />

      {/* Slide-in Menu */}
      <div className={`fixed top-0 right-0 h-full w-[80%] max-w-sm bg-[#FFF8F0] z-50 shadow-2xl transform transition-transform duration-300 ease-in-out flex flex-col ${isOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-133">
        <div className="flex justify-between items-center p-6 border-b border-[#F8C8DC]" data-id="element-134">
          <span className="font-heading font-bold text-xl text-[#2D1A1A]" data-id="element-135">
            Menu
          </span>
          <button onClick={onClose} className="p-2 text-[#6B1D4A] hover:bg-[#F8C8DC] rounded-full transition-colors" data-id="element-136">
            <XIcon className="w-6 h-6" data-id="element-137" />
          </button>
        </div>

        <nav className="flex flex-col p-6 space-y-6 flex-grow" data-id="element-138">
          <NavLink to="/" onClick={onClose} className={({
          isActive
        }) => `font-body text-xl font-medium ${isActive ? 'text-[#E91E8C]' : 'text-[#2D1A1A]'}`} data-id="element-139">
            Home
          </NavLink>
          <NavLink to="/collections" onClick={onClose} className={({
          isActive
        }) => `font-body text-xl font-medium ${isActive ? 'text-[#E91E8C]' : 'text-[#2D1A1A]'}`} data-id="element-140">
            Collections
          </NavLink>
          <NavLink to="/about" onClick={onClose} className={({
          isActive
        }) => `font-body text-xl font-medium ${isActive ? 'text-[#E91E8C]' : 'text-[#2D1A1A]'}`} data-id="element-141">
            About
          </NavLink>
          <NavLink to="/contact" onClick={onClose} className={({
          isActive
        }) => `font-body text-xl font-medium ${isActive ? 'text-[#E91E8C]' : 'text-[#2D1A1A]'}`} data-id="element-142">
            Contact
          </NavLink>
          <div className="pt-6 border-t border-[#F8C8DC]" data-id="element-143">
            <a href="https://shop.butter-blonde.com" target="_blank" rel="noopener noreferrer" className="font-body text-xl font-bold text-[#E91E8C] flex items-center" data-id="element-144">
              Shop <span className="ml-2 text-sm" data-id="element-145">↗</span>
            </a>
          </div>
        </nav>

        <div className="p-6 bg-[#F8C8DC] bg-opacity-30" data-id="element-146">
          <p className="font-script text-2xl text-[#6B1D4A] text-center" data-id="element-147">
            Stack your story
          </p>
        </div>
      </div>
    </>;
}